import styled from 'styled-components'

export const CampaignsWrapper = styled.div`
  .filters {
    display: flex,
    flex-direction: column,
  }

  .filters__item + * {
    margin-top: 12px;
  }

  .filters__item > * + * {
    margin-left: 12px;
  }
  .create-campaign {
    position: absolute;
    right: 40px;
    top: 55px;
    background: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
    font-family: ${props => props.theme.fonts.robotoRegular};
    label {
      padding: 0;
    }
  }
`
